import React, { useState, useEffect, useRef } from "react";
import { Typography } from "@mui/material";
import OtpInput from "react-otp-input";
import moment from "moment";

import { withRouter } from "react-router";
import { compose } from "underscore";
import { connect } from "react-redux";
import {
  sendEmailOtp,
  verifyEmailOtp,
  updateProfile,
} from "../../../redux/action";
import { PROFILE } from "../../../redux/constant";
import { StepLabel, CustomButton, DefaultLoader } from "../../../../components";
import { allowedIdType } from "../../../../utils/allowedIdType";
import { gatherIdentities } from "../../../../utils/functions/gatherIdentities";

import styles from "../../styles";
import "./index.css";

const VerifyEmail = props => {
  const {
    sendEmailOtp,
    verifyEmailOtp,
    updateProfile,
    profile,
    loadingUpdateProfile,
    loadingVerifyOtpEmail,
    history,
    match: { params },
  } = props;

  const email = params.email;

  const [emailOtp, setEmailOtp] = useState(null);
  const [resendOtp, setResendOtp] = useState(false);
  const [otpError, setOtpError] = useState({
    errorCode: null,
    message: "",
  });

  const [timeLeft, setTimeLeft] = useState(180);

  const submitted = useRef(false);

  const localIdentity = profile?.identities?.find(allowedIdType);

  const handleChangeOtp = token => {
    setEmailOtp(token);
  };

  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setTimeout(() => {
        setTimeLeft(timeLeft - 1);
      }, 1000);

      return () => clearTimeout(timer);
    }

    if (timeLeft === 0) {
      setResendOtp(true);
    }
  }, [timeLeft]);

  const handleVerifyEmail = () => {
    if (submitted.current) return;
    submitted.current = true;

    const payload = {
      masterId: profile.masterId, //R
      email: email, //R the updated
      mobileNo: profile.mobileNo, //R
      fullName: profile.fullName, //R
      townOfBirth: profile.townOfBirth, //R
      dob: moment(profile.dob).format("YYYY-MM-DD"), //R
      race: profile.race, //R
      natureOfBusinessCd: profile.natureOfBusinessCd, //R
      occupationTypeCd: profile.occupationTypeCd, //R
      maritalStatusCd: profile.maritalStatusCd, //R
      yearlyIncomeLevelCd: profile.yearlyIncomeLevelCd, //R
      sourceOfFundCd: profile.sourceOfFundCd,
      investmentObjCd: profile.investmentObjCd,
      employerName: profile.employerName,
      optIn: Boolean(profile?.optIn),
      isVc: Boolean(profile?.isVc),
      identities: gatherIdentities(profile, localIdentity),
      address: {
        line1: profile.contacts.find(
          contact => contact.contactTypeCd === "PERMANENT"
        ).line1, //R
        postCode: profile.contacts.find(contact => contact.postCode).postCode, //R
        city: profile.contacts.find(contact => contact.postCode).city, //R
        state: profile.contacts.find(contact => contact.state).state, //R,
        country: localIdentity?.citizenship, //R
      },
    };

    setOtpError({
      errorCode: null,
      message: "",
    });

    verifyEmailOtp(
      {
        email: email,
        token: emailOtp.toString(),
      },
      error => {
        submitted.current = false;
        if (error) {
          setOtpError({
            errorCode: error.status,
            message:
              error.status === 400
                ? "You’ve entered the wrong verification code"
                : error?.message,
          });
          return;
        }

        updateProfile({
          payloadData: payload,
          from: PROFILE,
        });
      }
    );
  };

  const handleResendOtp = () => {
    setTimeLeft(180);
    setResendOtp(false);
    setOtpError({
      errorCode: null,
      message: "",
    });
    setEmailOtp("");

    sendEmailOtp(
      {
        email: email.toLowerCase(),
        fullName: profile.fullName,
        cifId: profile.masterId,
      },
      err => {
        setOtpError({
          message: err?.message,
          errorCode: err?.status,
        });
      }
    );
  };

  return (
    <div style={{ backgroundColor: "#fff", ...styles.container }}>
      {(loadingUpdateProfile || loadingVerifyOtpEmail) && <DefaultLoader />}
      <StepLabel
        title="Verify Email"
        onClick={() => history.back()}
        containerStyles={{ margin: "16px 16px 22px" }}
      />
      <div style={{ margin: "0 16px 24px" }}>
        <Typography
          style={{
            ...styles.baseFont,
            ...styles.inputLabel,
            lineHeight: 1.29,
            color: "#505050",
          }}
        >
          <span style={{ fontWeight: "normal" }}>
            An email with a 6 digit verification code has been sent to
          </span>{" "}
          {email}.
        </Typography>
      </div>
      <div
        style={{
          margin: "0 16px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <OtpInput
          value={emailOtp}
          onChange={handleChangeOtp}
          numInputs={6}
          isInputNum={true}
          separator={<span>-</span>}
          hasErrored={false}
          className="otp"
          inputStyle={{ ...styles.baseFont, ...styles.otp }}
          errorStyle={{ color: "#be0712", border: "solid 1px #be0712" }}
          // focusStyle={{ color: "#1278cc", border: "solid 1px #1278cc" }}
        />
        {Boolean(otpError.errorCode) && (
          <Typography
            style={{
              ...styles.baseFont,
              fontSize: "14px",
              lineHeight: 1.57,
              color: "#be0712",
              marginTop: "16px",
            }}
          >
            {otpError.message}
          </Typography>
        )}

        {otpError.errorCode !== 429 && (
          <>
            <Typography
              style={{
                ...styles.baseFont,
                marginTop: "24px",
                fontWeight: "bold",
              }}
            >
              Didn't get verification code?
            </Typography>
            <Typography
              style={{
                ...styles.baseFont,
                color: !resendOtp ? "#505050" : "#1278cc",
              }}
            >
              {timeLeft > 0 && `Resend (${timeLeft}s)`}
              {resendOtp && (
                <span onClick={handleResendOtp}>Click Here to Resend</span>
              )}
            </Typography>
          </>
        )}
      </div>
      <div style={styles.btnContainer}>
        <CustomButton
          text="Next"
          variant="contained"
          color="#fff"
          backgroundColor="#1278CC"
          disabled={!emailOtp || otpError.errorCode === 429}
          onClick={handleVerifyEmail}
        />
      </div>
    </div>
  );
};

const withConnect = connect(
  state => ({
    loadingUpdateProfile: state.goal.loadingUpdateProfile,
    loadingVerifyOtpEmail: state.goal.loadingVerifyOtpEmail,
    profile: state.goal.profile,
  }),
  { sendEmailOtp, verifyEmailOtp, updateProfile }
);

export default compose(
  withRouter,
  withConnect
)(VerifyEmail);


